export default {
      id: "oc-menu-compute-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-compute",
      toString: function () {
        return this.url;
      }
    }